import {
	PremiumModules,
	PremiumModuleElement,
	PremiumTokenError,
	MyPremium,
	PremiumDiscountType,
	CouponState,
	MyPremiumState,
	PaymentIntentState
} from './extra.model';
import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { ErrorMessage } from '../error/error-message.model';

export const premiumCouponInitialState: CouponState = {
	randomString: undefined
};

export const paymentIntentInitialState: PaymentIntentState = {
	completePaymentIntent: undefined,
	paymentSuccess: false
};

export const myPremiumInitialState: MyPremiumState = {
	premiumState: undefined,
	myModules: undefined
};

// List

export interface PremiumModulesState extends EntityState<PremiumModuleElement> {
	error: ErrorMessage;
}

export const premiumModulesAdapter: EntityAdapter<PremiumModuleElement> =
	createEntityAdapter<PremiumModuleElement>({
		selectId: (PremiumModules) => PremiumModules.moduleId
	});

export const premiumModulesInitialState: PremiumModulesState =
	premiumModulesAdapter.getInitialState({
		error: undefined
	});

export const premiumModulesSelectors = premiumModulesAdapter.getSelectors();

export interface PremiumCheckTokenState extends EntityState<PremiumTokenError> {
	error: ErrorMessage;
}

export const premiumCheckTokenAdapter: EntityAdapter<PremiumTokenError> =
	createEntityAdapter<PremiumTokenError>({
		selectId: (CodiceScontoCheck) => CodiceScontoCheck.errorCode
	});

export const premiumCheckTokenInitialState: PremiumCheckTokenState =
	premiumCheckTokenAdapter.getInitialState({
		error: undefined
	});

export const premiumCheckTokenSelectors = premiumCheckTokenAdapter.getSelectors();

// DiscountList

export interface PremiumDiscountListState extends EntityState<PremiumDiscountType> {
	error: ErrorMessage;
}

export const premiumDiscountListAdapter: EntityAdapter<PremiumDiscountType> =
	createEntityAdapter<PremiumDiscountType>({
		selectId: (DiscountType) => DiscountType.discountTypeId
	});

export const premiumDiscountListInitialState: PremiumDiscountListState =
	premiumDiscountListAdapter.getInitialState({
		error: undefined
	});

export const premiumDiscountLisSelectors = premiumDiscountListAdapter.getSelectors();
